'use client'
import { useRef, useCallback } from 'react';

/**
 * This hook is used to generate a unique ID for a given WalletConnector.
 * This is used to ensure the wagmi connector id will change if the wallet connector
 * instance changes between rerenders.
 */
const useConnectorId = () => {
    const lastSeenWalletConnector = useRef(undefined);
    const lastConnectorKey = useRef(0);
    /**
     * This function will generate a unique ID for a given WalletConnector.
     */
    return useCallback((walletConnector) => {
        if (walletConnector !== lastSeenWalletConnector.current) {
            lastSeenWalletConnector.current = walletConnector;
            lastConnectorKey.current += 1;
        }
        return `dynamic-${walletConnector.key}-${lastConnectorKey.current}`;
    }, []);
};

export { useConnectorId };
